import React from 'react';
import { useTranslation } from 'react-i18next';
import { UNIQUENESS_STATUS } from '../../constants/uniquenessStatus';
import './UniquenessMessage.scss';

function UniquenessMessage({ status, name }) {
    const [t] = useTranslation();

    if (!status) return null;

    switch (status) {
        case UNIQUENESS_STATUS.CHECKING:
            return (
                <div className="uniqueness-message checking">
                    {t('COMMON:UNIQUENESS_CHECKING')}
                </div>
            );
        case UNIQUENESS_STATUS.UNIQUE:
            return (
                <div className="uniqueness-message unique">
                    {t('COMMON:UNIQUENESS_AVAILABLE', { name })}
                </div>
            );
        case UNIQUENESS_STATUS.NOT_UNIQUE:
            return (
                <div className="uniqueness-message not-unique">
                    {t('COMMON:UNIQUENESS_NOT_AVAILABLE', { name })}
                </div>
            );
        default:
            return null;
    }
}

export default UniquenessMessage;
